import React, { useEffect, useRef, useState } from 'react';
import '../styles/HarvestHorizonHero.css';

import CarouselImg from '../images/Carousel.jpg';
import Carousel1Img from '../images/Carousel1.jpg';
import Carousel4Img from '../images/Carousel4.jpg';
import Carousel5Img from '../images/Carousel5.jpg';
import Carousel6Img from '../images/Carousel6.jpg';
import BenSteffenImg from '../images/Ben_Stiffen.jpeg';
import ConnieBowenImg from '../images/Connie_Bowen.jpeg';
import MargaretOldhamImg from '../images/Margaret_Oldham.jpeg';
import EricRaileImg from '../images/Eric_Raile.jpg';
import ManitaThapaImg from '../images/Manita_Thapa.jpg';
import AnkitChandraImg from '../images/Ankit_Chandra.jpg';
import JoshGelinskeImg from '../images/Josh_Gelinske.jpg';
import SamJacksonImg from '../images/Sam_Jackson.jpg';
import TimJonesImg from '../images/Tim_Jones.jpg';
import TalaAwadaImg from '../images/Tala_Awada.jpg';
import DanKellyImg from '../images/Dan_Kelly.jpg';
import SeanCarrImg from '../images/Sean_Carr.jpg';
import KimberlyZarecorImg from '../images/Kimberly_Zarecor.jpg';
import NadiliaGomezImg from '../images/Nadilia_Gomez.jpg';
import BrennanCostelloImg from '../images/Brennan_Costello.jpg';
import JohnGatesImg from '../images/John_Gates.jpg';
import DimitrisZermasImg from '../images/Dimitris_Zermas.jpg';
import BenWilliamsonImg from '../images/Ben_Williamson.jpg';
import QuentinConnealyImg from '../images/Quentin_Connealy.jpg';
import SherryVintonImg from '../images/Sherry_Vinton.jpg';
import HollieMackeyImg from '../images/Hollie_Mackey.jpg';
import BonnieBraytonImg from '../images/Bonnie_Brayton.jpg';
import JessiKorinekImg from '../images/Jessi_Korinek.jpg';
import TracyZinkImg from '../images/Tracy_Zink.jpg';
import PosterSessionFlyer from '../images/PosterSessionFlyer.png';
import FTACPoster from '../images/FTAC_poster.jpeg';

import WomenInAgTechOnePager from '../docs/Women_in_Midwest_AgTech_One-Pager.pdf';
import ConvergenceOnePager from '../docs/Convergence_of_NSF_Innovation_Engines_One-Pager.pdf';

import NebraskaExtensionLogo from '../images/nebraska-extension.png';
import BioNebraskaLogo from '../images/bio-nebraska.jpg';
import CVALogo from '../images/cva.jpg';
import NebraskaCornBoardLogo from '../images/nebraska-corn-board.webp';
import NebraskaDWEELogo from '../images/nebraska-dwee.png';
import WaterForFoodLogo from '../images/water-for-food.jpeg';
import NebraskaTechCollaborativeLogo from '../images/nebraska-tech-collaborative.jpg';
import NUTechVenturesLogo from '../images/nutech-ventures.png';
import NebraskaInnovationCampusLogo from '../images/nebraska-innovation-campus.png';
import IndustryRelationsLogo from '../images/industry-relations.png';
import IANRLogo from '../images/ianr.png';
import AgriculturalResearchDivisionLogo from '../images/agricultural-research-division.png';
import CASNRLogo from '../images/casnr.png';
import BiologicalSystemsEngineeringLogo from '../images/biological-systems-engineering.png';
import SPNLogo from '../images/spn.webp';

import VandWaterLogo from '../images/startups/vand-water.png';
import TrilogyLogo from '../images/startups/trilogy.png';
import TerraformTillageLogo from '../images/startups/terraform-tillage.png';
import StartupSLogo from '../images/startups/startup-s.png';
import RemedyBioLogo from '../images/startups/remedy-bio.png';
import FarmsteadSenseLogo from '../images/startups/farmstead-sense.png';


const REGISTRATION_URL =
  'https://cvent.me/9E05M7';

const FTAC_STARTUP_URL =
  'https://forms.cloud.microsoft/pages/responsepage.aspx?id=xAPQGhOJLkyxIGKu-ItszRXzT9VQp_xNskPnO7MBrzxUQ0JJR0pIR01ZSlZIMzRXV0VPS0hJWEVaTy4u&route=shorturl';

const STUDENT_REGISTRATION_URL =
  'https://forms.cloud.microsoft/pages/responsepage.aspx?id=xAPQGhOJLkyxIGKu-ItszRXzT9VQp_xNskPnO7MBrzxUNURaN1haQUs2NEI3UlZBQkJOREtIOU05WS4u&route=shorturl';


const NEBRASKA_AGTECH_RESOURCES_URL =
  'https://digitalcommons.unl.edu/biosysengpres/91/';


/* =========================================================
   SPONSORS & PARTNERS
   ========================================================= */

const sponsorLogos = [

  {
    name: 'Nebraska Extension',
    image: NebraskaExtensionLogo,
  },

  {
    name: 'Bio Nebraska',
    image: BioNebraskaLogo,
  },

  {
    name: 'CVA',
    image: CVALogo,
  },

  {
    name: 'Nebraska Corn Board',
    image: NebraskaCornBoardLogo,
  },

  {
    name: 'Nebraska Department of Water, Energy and Environment',
    image: NebraskaDWEELogo,
  },

  {
    name: 'Daugherty Water for Food Global Institute',
    image: WaterForFoodLogo,
  },

  {
    name: 'Nebraska Tech Collaborative',
    image: NebraskaTechCollaborativeLogo,
  },

  {
    name: 'NUtech Ventures',
    image: NUTechVenturesLogo,
  },

  {
    name: 'Nebraska Innovation Campus',
    image: NebraskaInnovationCampusLogo,
  },

  {
    name: 'Industry Relations',
    image: IndustryRelationsLogo,
  },

  {
    name: 'Institute of Agriculture and Natural Resources',
    image: IANRLogo,
  },

  {
    name: 'Agricultural Research Division',
    image: AgriculturalResearchDivisionLogo,
  },

  {
    name: 'College of Agricultural Sciences and Natural Resources',
    image: CASNRLogo,
  },

  {
    name: 'Biological Systems Engineering',
    image: BiologicalSystemsEngineeringLogo,
  },

  {
    name: 'SPN',
    image: SPNLogo,
  },

];


/* =========================================================
   STARTUPS
   ========================================================= */

const startupLogos = [

  { name: 'Vand Water', image: VandWaterLogo },

  { name: 'Trilogy', image: TrilogyLogo },

  { name: 'Terraform Tillage', image: TerraformTillageLogo },

  { name: 'Startup', image: StartupSLogo },

  { name: 'Remedy Bio', image: RemedyBioLogo },

  { name: 'Farmstead Sense', image: FarmsteadSenseLogo },

];


/* =========================================================
   HOTEL OPTIONS
   ========================================================= */

const hotelOptions = [

  {
    name: 'Grand Island Casino Resort',

    label:
      'Official AgConverge Hotel',

    address:
      '777 E. Fonner Park Road, Grand Island, NE 68801',

    phone:
      '(308) 675-5600',

    description:
      'Located directly at Fonner Park, Grand Island Casino Resort is the official hotel for Spur AgConverge 2026 attendees.',

    url:
      'https://www.grandislandresort.com/hotel.html',

    isOfficialBlock: true,

    specialRate:
      '$119.95/night',

    groupCode:
      '10300N',

    bookBy:
      'October 16, 2026',

    blockMessage:
      'Use group code 10300N when booking your room to receive the special AgConverge rate. The discounted room block is subject to availability.',
  },


  {
    name:
      'Travelodge by Wyndham Grand Island',

    label:
      'Adjacent to Fonner Park',

    address:
      '1311 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 594-0123',

    description:
      'A convenient budget-friendly hotel adjacent to Fonner Park and close to the Heartland Events Center. Amenities include free Wi-Fi, free parking, pet-friendly rooms, and airport shuttle service.',

    url:
      'https://www.wyndhamhotels.com/travelodge/grand-island-nebraska/grand-island-travelodge/overview',
  },


  {
    name:
      'SureStay Plus Hotel by Best Western Grand Island',

    label:
      'About 0.5 mile from Fonner Park',

    address:
      '2603 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 384-4380',

    description:
      'A nearby hotel on South Locust Street within easy reach of Fonner Park. Guests have access to complimentary breakfast, Wi-Fi, an indoor pool, fitness facilities, and free parking.',

    url:
      'https://www.bestwestern.com/en_US/book/hotel-rooms.54219.html',
  },


  {
    name:
      'Island Inn',

    label:
      'Near Fonner Park',

    address:
      '2311 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 382-1815',

    description:
      'A simple and affordable lodging option on South Locust Street close to the Fonner Park event area. Rooms include refrigerators, wireless internet, and free local calls.',

    url:
      'http://www.stayislandinn.com',
  },


  {
    name:
      'Best Western Plus Grand Island Inn & Suites',

    label:
      'About 1 mile from the event center',

    address:
      '2707 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 675-5656',

    description:
      'Located minutes from the Heartland Events Center, Fonner Park, and Nebraska State Fairgrounds. Amenities include a full hot breakfast, indoor heated pool, fitness center, Wi-Fi, and free parking.',

    url:
      'https://www.bestwestern.com/en_US/book/grand-island/hotel-rooms/best-western-plus-grand-island-inn-suites/propertyCode.28071.html',
  },


  {
    name:
      'Ramada by Wyndham Midtown Grand Island',

    label:
      'Near Fonner Park',

    address:
      '2503 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 384-1330',

    description:
      'A full-service hotel near the Heartland Events Center and Fonner Park with an indoor pool, on-site dining, conference facilities, breakfast, Wi-Fi, and parking.',

    url:
      'https://www.wyndhamhotels.com/ramada/grand-island-nebraska/ramada-midtown-grand-island/overview',
  },


  {
    name:
      'MainStay Suites Grand Island',

    label:
      'About 1 mile from Fonner Park',

    address:
      '3051 S. Locust Street, Grand Island, NE 68801',

    phone:
      '(308) 646-2091',

    description:
      'An extended-stay hotel near the Nebraska State Fairgrounds and Fonner Park with apartment-style suites, in-room kitchens, complimentary Wi-Fi, breakfast, and parking.',

    url:
      'https://www.choicehotels.com/nebraska/grand-island/mainstay-hotels/ne131',
  },

];


/* =========================================================
   PANEL LINEUPS
   ========================================================= */

const industryAcademiaPanel = [
  { name: 'Brennan Costello', title: 'Director', org: 'The Combine', moderator: true, image: BrennanCostelloImg },
  { name: 'John Gates', title: 'Chief Revenue Officer', org: 'CropX', image: JohnGatesImg },
  { name: 'Dimitris Zermas', title: 'Director, Machine Learning', org: 'John Deere', image: DimitrisZermasImg },
  { name: 'Ben Williamson', title: 'General Partner', org: 'Grit Road Partners', image: BenWilliamsonImg },
  { name: 'Quentin Connealy', title: 'Farmer', org: 'Q Connealy Farms', farmer: true, image: QuentinConnealyImg },
];

const womenInAgTechPanel = [
  { name: 'Sherry Vinton', title: 'Director', org: 'Nebraska Department of Agriculture', moderator: true, image: SherryVintonImg },
  { name: 'Hollie Mackey', title: 'CEO', org: 'NSF AgTech Engine', image: HollieMackeyImg },
  { name: 'Jessi Korinek', title: 'CEO', org: 'Nave Analytics', image: JessiKorinekImg },
  { name: 'Bonnie Brayton', title: 'Managing Director', org: 'InnoVenture Iowa', image: BonnieBraytonImg },
  { name: 'Tracy Zink', title: 'Farmer', org: '', farmer: true, image: TracyZinkImg },
];

const convergencePanel = [
  { name: 'Ankit Chandra', title: 'Founder and Director', org: 'Spur Ventures', moderator: true, image: AnkitChandraImg },
  { name: 'Josh Gelinske', title: 'Chief Technology and Innovation Officer', org: 'NSF AgTech Engine (North Dakota)', image: JoshGelinskeImg },
  { name: 'Sam Jackson', title: 'CEO', org: 'NSF BRIDGES Engine (Tennessee)', image: SamJacksonImg },
  { name: 'Kimberly Zarecor', title: 'Adviser to the CEO', org: 'NSF RuralSTAMINA Engine (Iowa/Nebraska)', image: KimberlyZarecorImg },
  { name: 'Tim Jones', title: 'Translation Director', org: 'NSF ASCEND Engine (Colorado)', image: TimJonesImg },
];

const bioEconomyPanel = [
  { name: 'Tala Awada', title: 'Interim Dean & Director, Agricultural Research Division', org: 'University of Nebraska–Lincoln', moderator: true, image: TalaAwadaImg },
  { name: 'Nadilia Gomez', title: 'CTO', org: 'Iowa State University', image: NadiliaGomezImg },
  { name: 'Dan Kelly', title: 'CEO', org: 'ADAR Technologies', image: DanKellyImg },
  { name: 'Sean Karr', title: 'CEO', org: 'MTE Biotech', image: SeanCarrImg },
  { name: 'Margaret Arulananda', title: 'Strategic Transformation Director', org: 'Evonik' },
];


const trustWorkshopFacilitators = [
  { name: 'Eric Raile', org: 'Montana State University', image: EricRaileImg },
  { name: 'Manita Thapa', org: 'North Dakota State University', image: ManitaThapaImg },
];


/* =========================================================
   SESSION DATA
   ========================================================= */

const sessionData = {

  day1: [

    {
      icon:
        'fa-mug-hot',

      title:
        'Registration & Coffee',

      desc:
        'Exhibits and Startup Demonstration Stations open.',

      time:
        '8:00 – 9:00 AM',

      type:
        'networking',
    },


    {
      icon:
        'fa-microphone',

      title:
        'Welcome & Framing the Two Days',

      time:
        '9:00 – 9:10 AM',
    },


    {
      icon:
        'fa-bullhorn',

      title:
        'Opening Address',

      desc:
        'Ankit Chandra, Spur Ventures.',

      time:
        '9:10 – 9:30 AM',
    },


    /* =====================================================
       PRODUCER KEYNOTE — BEN STEFFEN
       ===================================================== */

    {
      icon:
        'fa-tractor',

      title:
        'Producer Keynote',

      desc:
        'What Farms Need Now: A Producer’s View on AgTech Innovation.',

      time:
        '9:30 – 10:00 AM',

      badge:
        'Keynote',

      type:
        'featured',

      isKeynote:
        true,

      speakerName:
        'Ben Steffen',

      speakerRole:
        'Producer Keynote Speaker',

      speakerImage:
        BenSteffenImg,

      speakerBio:
        'Ben Steffen is a proud Nebraska farmer, business owner, and longtime advocate for agriculture and rural communities. A University of Nebraska–Lincoln graduate, he farms land that has been in his family for more than 130 years and serves as President of Steffen Ag Inc. He is a former President of Ag Builders of Nebraska and currently chairs the Nebraska Rural Radio Association.',
    },


    {
      icon:
        'fa-coffee',

      title:
        'Networking Break',

      desc:
        'Startup Demonstration Stations featured.',

      time:
        '10:00 – 10:30 AM',

      type:
        'break',
    },


    {
      icon:
        'fa-rocket',

      title:
        'FTAC Phase 1: Startup Showcase',

      desc:
        'Six Selected Startups: Ten minutes pitch; your potential customers are in the room.',

      time:
        '10:30 – 11:45 AM',

      badge:
        'FTAC Phase 1',

      type:
        'featured',

      chairName:
        'Ankit Chandra',

      chairEmail:
        'achandra@unl.edu',

      coChairName:
        'Joy Eakin',

      coChairEmail:
        'jeakin@nutechventures.org',
    },


    {
      icon:
        'fa-people-arrows',

      title:
        'Transition to Lunch',

      desc:
        'Transition from the morning program to lunch.',

      time:
        '11:45 AM – 12:00 PM',

      type:
        'break',
    },


    /* =====================================================
       INDUSTRY KEYNOTE — CONNIE BOWEN
       ===================================================== */

    {
      icon:
        'fa-utensils',

      title:
        'Lunch & Industry Keynote',

      desc:
        'Where Capital Is Going: Market Conditions and the Future of AgTech Investment. The keynote is scheduled from 12:20–12:45 PM.',

      time:
        '12:00 – 1:00 PM',

      badge:
        'Keynote · Lunch',

      type:
        'meal',

      isKeynote:
        true,

      speakerName:
        'Connie Bowen',

      speakerRole:
        'Industry Keynote Speaker',

      speakerImage:
        ConnieBowenImg,

      speakerBio:
        'Connie Bowen is a leader in agricultural innovation and investment with experience investing in 50+ agtech startups over the past decade. She is the founding General Partner at Farmhand Ventures, an impact investment firm shaping the Future of Work in Agriculture by enabling strategic programs and innovation to make farm work more attractive, productive, and sustainable—improving the lives and livelihoods of farmers, farmworkers, and rural communities. Connie has built a career connecting agricultural technology with practical farming needs and sustainable technology investment at The Yield Lab, AgLaunch, Chess Ag Full Harvest Partners, and Grape Arbor Ventures.',
    },


    {
      icon:
        'fa-table',

      title:
        'Track A: FTAC Phase 2 — Farmer Evaluation Roundtables',

      desc:
        'Farmers, founders, and facilitators participate in a closed evaluation session.',

      time:
        '1:00 – 2:15 PM',

      badge:
        'Closed session',

      type:
        'track',

      chairName:
        'Ankit Chandra',

      chairEmail:
        'achandra@unl.edu',

      coChairName:
        'Joy Eakin',

      coChairEmail:
        'jeakin@nutechventures.org',
    },


    {
      icon:
        'fa-users',

      title:
        'Track B: Industry–Academia Partnership Panel',

      desc:
        'Concurrent Session — Track B runs alongside FTAC Phase 2 (Track A). From Research to Impact: the Industry–Academia Partnership Panel runs from 1:05–1:45 PM, followed by open demonstration time until 2:15 PM.',

      time:
        '1:00 – 2:15 PM',

      badge:
        'Concurrent Session · Track B',

      type:
        'track',

      panelists:
        industryAcademiaPanel,

      chairName:
        'Ankit Chandra',

      chairEmail:
        'achandra@unl.edu',

      coChairName:
        'Ryan Anderson',

      coChairEmail:
        'randerson13@unl.edu',
    },


    {
      icon:
        'fa-robot',

      title:
        'Afternoon Break',

      desc:
        'Robotics & Technology Demonstration Arena featured.',

      time:
        '2:15 – 2:45 PM',

      type:
        'break',

      chairName:
        'Dr. Santosh Pitla',

      chairEmail:
        'spitla@nebraska.edu',
    },


    {
      icon:
        'fa-award',

      title:
        'FTAC Phase 3: Producer Verdict & Farm Awards',

      desc:
        'Roundtable reports, judging panel, producer verdicts, and awards presentation.',

      time:
        '2:45 – 3:45 PM',

      badge:
        'FTAC Phase 3',

      type:
        'featured',
    },


    {
      icon:
        'fa-coffee',

      title:
        'Break',

      desc:
        'Short transition before the afternoon fireside chat.',

      time:
        '3:45 – 4:00 PM',

      type:
        'break',
    },


    {
      icon:
        'fa-comments',

      title:
        'Founder × Farmer Fireside Chat I',

      desc:
        'Beyond the Pitch: a founder × farmer conversation on technology adoption and real-world use.',

      time:
        '4:00 – 4:40 PM',

      badge:
        'Fireside chat',

      type:
        'featured',

      startupName:
        'iCrop',

      farmerName:
        'Clark McPheeters',

      chairName:
        'Mark Stone',

      chairEmail:
        'mark.stone@unl.edu',
    },


    /* =====================================================
       AGLAUNCH SPECIAL — MARGARET OLDHAM
       ===================================================== */

    {
      icon:
        'fa-seedling',

      title:
        'AgLaunch Special: Farmer-centric incentive and innovation model',

      desc:
        'In this special 20-minute session, Margaret Oldham from AgLaunch will share how their farmer-driven innovation model helps startups identify real-world agricultural challenges, co-develop and test solutions with farmers, and create opportunities and incentives for farmers to share in the financial value of the innovations they help bring to market.',

      time:
        '4:40 – 5:00 PM',

      badge:
        'Special Session',

      type:
        'featured',

      isKeynote:
        true,

      speakerName:
        'Margaret Oldham',

      speakerRole:
        'General Partner, Farmers Innovation Fund II · AgLaunch',

      speakerImage:
        MargaretOldhamImg,

      speakerBio:
        'Margaret Oldham is an agricultural industry veteran with deep experience in entrepreneurship, innovation, marketing, and business development. As General Partner of Farmers Innovation Fund II, a $50 million USDA-licensed rural investment fund, she leads investment in early-stage agtech that solves real farmer challenges. She has advanced AgLaunch’s farmer-centered innovation model, supporting 40+ startups and a 40,000-member agricultural network, and has worked with leading companies including FMC, Elanco, BASF, Bayer and John Deere.',
    },


    {
      icon:
        'fa-handshake',

      title:
        'Networking Reception & Student Poster Session',

      desc:
        'AgConverge Connect partner meetups, student posters, networking, and open exhibits.',

      time:
        '5:00 – 6:30 PM',

      badge:
        'Reception',

      type:
        'networking',

      chairName:
        'Ishani Lal',

      chairEmail:
        'ilal2@unl.edu',

      coChairName:
        'Alexa Davis',

      coChairEmail:
        'alexa.davis@nebraska.gov',
    },

  ],


  day2: [

    {
      icon:
        'fa-chart-line',

      title:
        'Investor–Startup Breakfast',

      desc:
        'Invitation-only breakfast for showcase startups, investors, and corporate venture teams.',

      time:
        '8:00 – 9:00 AM',

      badge:
        'Invitation only',

      type:
        'meal',
    },


    {
      icon:
        'fa-mug-hot',

      title:
        'Coffee & Networking',

      desc:
        'AgConverge Connect partner meetups, open exhibits, and students presenting at their posters.',

      time:
        '8:15 – 9:00 AM',

      badge:
        'Open networking',

      type:
        'networking',
    },


    {
      icon:
        'fa-microphone',

      title:
        'Welcome Back',

      time:
        '9:00 – 9:05 AM',
    },


    {
      icon:
        'fa-comments',

      title:
        'Convergence of NSF Innovation Engines',

      desc:
        'Conversation on translation and commercialization of agtech through the Spur and Innovation engines.',

      time:
        '9:00 – 9:50 AM',

      badge:
        'Panel',

      panelists:
        convergencePanel,

      docUrl:
        ConvergenceOnePager,

      docLabel:
        'Convergence of NSF Innovation Engines one-pager',

      type:
        'featured',

      chairName:
        'Ishani Lal',

      chairEmail:
        'ilal2@unl.edu',

      coChairName:
        'Josh Gelinske',

      coChairEmail:
        'josh@farmsengine.com',
    },


    {
      icon:
        'fa-users',

      title:
        'Women in Midwest AgTech',

      desc:
        'Women Shaping the Future of Agricultural Innovation.',

      time:
        '10:00 – 10:50 AM',

      badge:
        'Panel',

      docUrl:
        WomenInAgTechOnePager,

      docLabel:
        'Women in Midwest AgTech one-pager',

      type:
        'featured',

      panelists:
        womenInAgTechPanel,

      chairName:
        'Ishani Lal',

      chairEmail:
        'ilal2@unl.edu',

      coChairName:
        'Alexa Davis',

      coChairEmail:
        'alexa.davis@nebraska.gov',
    },


    {
      icon:
        'fa-handshake',

      title:
        'Producer and Innovator Mini-Workshop: Trust and the Adoption of AgTech Innovations',

      desc:
        'Trust strongly influences agtech adoption: about 90% of the 900+ Great Plains producers surveyed rated trust in tech reps and in companies as important, yet there is no single formula for building it. The workshop isn’t looking for shortcuts to trust, but for common ground on how producers and innovators can work together to get the right agtech into producers’ hands. In four brisk stages, producers and innovators first discuss trust in separate groups, then report out, and finally reflect together on ways to build trust more successfully.',

      time:
        '10:50 – 11:40 AM',

      badge:
        'Mini-Workshop · Concurrent',

      type:
        'featured',

      facilitators:
        trustWorkshopFacilitators,

      concurrentGroup:
        'brunch-workshop',

      concurrentLabel:
        '10:50 AM – 12:00 PM',
    },


    {
      icon:
        'fa-robot',

      title:
        'Brunch',

      desc:
        '',

      lines: [
        { icon: 'fa-utensils', text: 'Grab lunch and network with participants' },
        { icon: 'fa-robot', text: 'Explore tech demonstrations and exhibit booths' },
        { icon: 'fa-handshake', text: 'Attend the mini-workshop' },
      ],

      time:
        '10:50 AM – 12:00 PM',

      badge:
        'Concurrent Session',

      type:
        'break',

      concurrentGroup:
        'brunch-workshop',

      concurrentLabel:
        '10:50 AM – 12:00 PM',

      chairEmail:
        'spitla@nebraska.edu',
    },


    {
      icon:
        'fa-leaf',

      title:
        'Bio-economy Panel',

      desc:
        'From Commodity to Bioproduct: Building the Regional Bio-economy.',

      time:
        '12:00 – 12:50 PM',

      badge:
        'Panel',

      type:
        'featured',

      panelists:
        bioEconomyPanel,

      chairName:
        'Zane Gernhart',

      chairEmail:
        'zgernhart2@unl.edu',
    },


    {
      icon:
        'fa-bullhorn',

      title:
        'Closing Address',

      desc:
        'Ankit Chandra, Spur Ventures.',

      time:
        '12:50 – 1:00 PM',
    },


    {
      icon:
        'fa-flag-checkered',

      title:
        'Farewell',

      time:
        '1:00 PM',
    },

  ],

};


/* =========================================================
   DAY TABS
   ========================================================= */

const tabs = [

  {
    key:
      'day1',

    day:
      'Day 1',

    date:
      'Tuesday, November 17',
  },

  {
    key:
      'day2',

    day:
      'Day 2',

    date:
      'Wednesday, November 18',
  },

];


/* =========================================================
   SPUR 2025 HIGHLIGHT IMAGES
   ========================================================= */

const heroSlides = [

  {
    image:
      CarouselImg,

    alt:
      'Spur Ventures event',

    label:
      '2025 Highlight 01',

    position:
      'center',
  },


  {
    image:
      Carousel1Img,

    alt:
      'Spur Ventures conference gathering',

    label:
      '2025 Highlight 02',

    position:
      'center',
  },


  {
    image:
      Carousel4Img,

    alt:
      'Agricultural innovation event',

    label:
      '2025 Highlight 03',

    position:
      'center',
  },


  {
    image:
      Carousel5Img,

    alt:
      'AgTech networking event',

    label:
      '2025 Highlight 04',

    position:
      'center',
  },


  {
    image:
      Carousel6Img,

    alt:
      'Spur Ventures community event',

    label:
      '2025 Highlight 05',

    position:
      'center',
  },

];


const getInitials = (name) =>
  name
    .replace(/^(Dr\.|Mr\.|Ms\.|Mrs\.)\s+/i, '')
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();


/* Panel lineup — simple list.
   Moderator first, then speakers: circle initials on the
   left, name / title / organization on the right. */

const PanelLineup = ({ panelists }) => {

  const moderator = panelists.find((person) => person.moderator);
  const members = panelists.filter((person) => !person.moderator);
  const people = moderator ? [moderator, ...members] : members;

  return (
    <div className="s-panel">

      <div className="s-panel-heading">
        Speakers
        <span className="s-panel-total">{panelists.length}</span>
      </div>

      <ul className="s-panel-people">

        {people.map((person) => (

          <li
            key={person.name}
            className={`s-person ${person.moderator ? 'is-moderator' : ''} ${person.farmer ? 'is-farmer' : ''}`}
          >

            <span className={`s-person-circle ${person.image ? 'has-photo' : ''}`} aria-hidden="true">
              {person.image
                ? <img src={person.image} alt="" loading="lazy" />
                : person.farmer
                  ? <i className="fas fa-tractor" />
                  : getInitials(person.name)}
            </span>

            <div className="s-person-info">

              <span className="s-person-name">
                {person.name}

                {person.moderator && (
                  <span className="s-person-badge is-moderator">Moderator</span>
                )}

                {person.farmer && (
                  <span className="s-person-badge is-farmer">Producer</span>
                )}
              </span>

              <span className="s-person-role">
                {person.title}
              </span>

              {person.org && (
                <span className="s-person-org">
                  {person.org}
                </span>
              )}

            </div>

          </li>

        ))}

      </ul>

    </div>
  );
};


/* Sessions that share a concurrentGroup are shown together,
   side by side, inside one highlighted block. */

const buildSessionRows = (sessions) => {

  const rows = [];
  const groups = {};

  sessions.forEach((session) => {

    if (!session.concurrentGroup) {
      rows.push({ item: session });
      return;
    }

    if (!groups[session.concurrentGroup]) {
      groups[session.concurrentGroup] = {
        group: session.concurrentGroup,
        label: session.concurrentLabel,
        items: [],
      };
      rows.push(groups[session.concurrentGroup]);
    }

    groups[session.concurrentGroup].items.push(session);

  });

  return rows;
};


/* Long text clamped to a few lines, with a Read more toggle. */

const ReadMore = ({ text }) => {

  const [open, setOpen] = useState(false);

  return (
    <div className="s-readmore">

      <p className={open ? 'is-open' : ''}>{text}</p>

      <button
        type="button"
        className="s-readmore-btn"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        {open ? 'Show less' : 'Read more'}
        <i className={`fas ${open ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true" />
      </button>

    </div>
  );
};


/* Facilitators — photo + name + organization, side by side. */

const Facilitators = ({ people }) => (
  <div className="s-facil">

    <div className="s-facil-heading">Facilitators</div>

    <ul className="s-facil-list">

      {people.map((person) => (

        <li key={person.name} className="s-facil-item">

          <img
            className="s-facil-photo"
            src={person.image}
            alt={person.name}
            loading="lazy"
          />

          <div className="s-facil-info">
            <span className="s-facil-name">{person.name}</span>
            <span className="s-facil-org">{person.org}</span>
          </div>

        </li>

      ))}

    </ul>

  </div>
);


/* Startup showcase — a clean card that shows a few logos at a
   time. Swipe, use the arrows, or tap the dots; it also moves
   along by itself and stops when someone interacts with it. */

const StartupShowcase = ({ items }) => {

  const viewport = useRef(null);
  const paused = useRef(false);
  const resumeTimer = useRef(null);

  const [page, setPage] = useState(0);
  const [pages, setPages] = useState(1);

  const measure = () => {
    const el = viewport.current;
    if (!el || !el.clientWidth) return;
    setPages(Math.max(1, Math.round(el.scrollWidth / el.clientWidth)));
    setPage(Math.round(el.scrollLeft / el.clientWidth));
  };

  const goTo = (index) => {
    const el = viewport.current;
    if (!el) return;
    el.scrollTo({ left: index * el.clientWidth, behavior: 'smooth' });
  };

  const hold = (ms) => {
    paused.current = true;
    window.clearTimeout(resumeTimer.current);
    resumeTimer.current = window.setTimeout(() => {
      paused.current = false;
    }, ms);
  };

  useEffect(() => {

    measure();

    window.addEventListener('resize', measure);

    const reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const timer = reduceMotion ? null : window.setInterval(() => {
      const el = viewport.current;
      if (!el || paused.current || document.hidden) return;
      const count = Math.max(1, Math.round(el.scrollWidth / el.clientWidth));
      const current = Math.round(el.scrollLeft / el.clientWidth);
      el.scrollTo({
        left: ((current + 1) % count) * el.clientWidth,
        behavior: 'smooth',
      });
    }, 4500);

    return () => {
      window.removeEventListener('resize', measure);
      window.clearInterval(timer);
      window.clearTimeout(resumeTimer.current);
    };

  }, []);

  const step = (direction) => {
    hold(9000);
    goTo((page + direction + pages) % pages);
  };

  return (
    <section
      className="s-startups"
      aria-label="Startups"
      onMouseEnter={() => { paused.current = true; }}
      onMouseLeave={() => hold(1200)}
      onFocus={() => { paused.current = true; }}
      onBlur={() => hold(1200)}
      onTouchStart={() => hold(9000)}
    >

      <div className="s-startups-head">
        <span className="s-startups-label">Featured Startups</span>
      </div>

      <div
        className="s-startups-viewport"
        ref={viewport}
        onScroll={measure}
      >
        <ul className="s-startups-track">
          {items.map((item) => (
            <li className="s-startups-item" key={item.name}>
              <span className="s-startups-tile">
                <img src={item.image} alt={item.name} loading="lazy" />
              </span>
            </li>
          ))}
        </ul>
      </div>

      {pages > 1 && (
        <div className="s-startups-foot">

          <div className="s-startups-dots" role="tablist" aria-label="Startup pages">
            {Array.from({ length: pages }).map((_, index) => (
              <button
                key={index}
                type="button"
                role="tab"
                aria-selected={index === page}
                aria-label={`Show startups page ${index + 1}`}
                className={`s-startups-dot ${index === page ? 'is-active' : ''}`}
                onClick={() => { hold(9000); goTo(index); }}
              />
            ))}
          </div>

          <div className="s-startups-arrows">
            <button
              type="button"
              className="s-startups-arrow"
              aria-label="Previous startups"
              onClick={() => step(-1)}
            >
              <i className="fas fa-chevron-left" aria-hidden="true" />
            </button>
            <button
              type="button"
              className="s-startups-arrow"
              aria-label="Next startups"
              onClick={() => step(1)}
            >
              <i className="fas fa-chevron-right" aria-hidden="true" />
            </button>
          </div>

        </div>
      )}

    </section>
  );
};


/* Logo carousel — scrolls on its own, pauses on hover/touch,
   and has arrows so visitors can move through it by hand.
   The list is rendered twice so the loop is seamless. */

const LogoCarousel = ({ items, label }) => {

  const viewport = useRef(null);
  const paused = useRef(false);
  const resumeTimer = useRef(null);

  const pauseFor = (ms) => {
    paused.current = true;
    window.clearTimeout(resumeTimer.current);
    if (ms) {
      resumeTimer.current = window.setTimeout(() => {
        paused.current = false;
      }, ms);
    }
  };

  useEffect(() => {

    const el = viewport.current;
    if (!el) return undefined;

    const reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let frame;

    const half = () => el.scrollWidth / 2;

    const tick = () => {
      if (!paused.current && !reduceMotion) {
        el.scrollLeft += 1;
      }
      if (el.scrollLeft >= half()) {
        el.scrollLeft -= half();
      }
      frame = window.requestAnimationFrame(tick);
    };

    frame = window.requestAnimationFrame(tick);

    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(resumeTimer.current);
    };

  }, []);

  const move = (direction) => {

    const el = viewport.current;
    if (!el) return;

    const step = Math.max(160, Math.round(el.clientWidth * 0.6));
    const half = el.scrollWidth / 2;

    /* Jump to the matching spot in the other copy first, so
       there is always room to scroll in either direction. */
    if (direction < 0 && el.scrollLeft < step) {
      el.scrollLeft += half;
    }

    pauseFor(4000);

    el.scrollBy({ left: direction * step, behavior: 'smooth' });

  };

  return (
    <div
      className="agc-carousel"
      onMouseEnter={() => pauseFor(0)}
      onMouseLeave={() => pauseFor(600)}
      onTouchStart={() => pauseFor(4000)}
    >

      <button
        type="button"
        className="agc-carousel-arrow is-prev"
        aria-label={`Scroll ${label} left`}
        onClick={() => move(-1)}
      >
        <i className="fas fa-chevron-left" aria-hidden="true" />
      </button>

      <div
        className="agc-sponsor-marquee"
        ref={viewport}
        role="region"
        aria-label={label}
      >
        <div className="agc-sponsor-track">

          {[0, 1].map((copy) => (
            <div
              className="agc-sponsor-group"
              key={copy}
              aria-hidden={copy === 1 ? 'true' : undefined}
            >
              {items.map((item) => (
                <div className="agc-sponsor-item" key={`${copy}-${item.name}`}>
                  <img
                    src={item.image}
                    alt={copy === 0 ? item.name : ''}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          ))}

        </div>
      </div>

      <button
        type="button"
        className="agc-carousel-arrow is-next"
        aria-label={`Scroll ${label} right`}
        onClick={() => move(1)}
      >
        <i className="fas fa-chevron-right" aria-hidden="true" />
      </button>

    </div>
  );
};


/* =========================================================
   COMPONENT
   ========================================================= */

const HarvestHorizonHero = ({

  timeLeft = {
    days: '--',
    hours: '--',
    minutes: '--',
  },

}) => {


  const [activeTab, setActiveTab] =
    useState('day1');


  const [
    heroSlideIndex,
    setHeroSlideIndex,
  ] = useState(0);


  const [
    travelMapQuery,
    setTravelMapQuery,
  ] = useState(
    'Hotels near Raising Nebraska, Grand Island, Nebraska'
  );


  const [
    selectedHotelName,
    setSelectedHotelName,
  ] = useState(null);


  const [
    posterImageOpen,
    setPosterImageOpen,
  ] = useState(false);


  const [
    ftacPosterOpen,
    setFtacPosterOpen,
  ] = useState(false);


  const selectedHotel =
    hotelOptions.find(
      (hotel) =>
        hotel.name === selectedHotelName
    ) || null;


  const travelMapEmbedUrl =
    `https://www.google.com/maps?q=${encodeURIComponent(
      travelMapQuery
    )}&output=embed`;


  const focusTravelLocation = (
    query,
    hotelName = null
  ) => {

    setTravelMapQuery(query);
    setSelectedHotelName(hotelName);

  };


  /* =========================================================
     HERO CAROUSEL AUTO ROTATION
     ========================================================= */

  useEffect(() => {

    const heroInterval =
      window.setInterval(() => {

        setHeroSlideIndex(
          (current) =>
            current ===
              heroSlides.length - 1

              ? 0

              : current + 1
        );

      }, 5000);


    return () => {

      window.clearInterval(
        heroInterval
      );

    };

  }, []);


  const previousHeroSlide = () => {

    setHeroSlideIndex(
      (current) =>
        current === 0

          ? heroSlides.length - 1

          : current - 1
    );

  };


  const nextHeroSlide = () => {

    setHeroSlideIndex(
      (current) =>
        current ===
          heroSlides.length - 1

          ? 0

          : current + 1
    );

  };


  const openRegistration = () => {

    window.open(
      REGISTRATION_URL,
      '_blank',
      'noopener,noreferrer'
    );

  };


  const renderSessionCard = (session) => {

    return (

                  <article

                    key={
                      `${session.time}-${session.title}`
                    }


                    className={`s-scard ${session.type

                      ? `is-${session.type}`

                      : ''
                      } ${session.isKeynote

                        ? 's-scard-keynote'

                        : ''
                      } ${session.panelists ? 's-scard-panel' : ''}`}


                  >


                    {/* TIME */}

                    <div
                      className="
                        s-scard-time-column
                      "
                    >

                      <span
                        className="
                          s-scard-time
                        "
                      >
                        {session.time}
                      </span>


                      {session.isKeynote && (

                        <span
                          className="
                            s-keynote-featured-label
                          "
                        >
                          Featured
                        </span>

                      )}


                      {session.panelists && (

                        <span className="s-keynote-featured-label">
                          {session.panelists.length} Speakers
                        </span>

                      )}

                    </div>


                    {/* ICON */}

                    <div
                      className={`s-scard-icon ${session.isKeynote

                        ? 's-keynote-session-icon'

                        : ''
                        }`}
                    >

                      <i
                        className={`fas ${session.icon}`}
                      />

                    </div>


                    {/* DETAILS */}

                    <div
                      className="
                        s-scard-details
                      "
                    >

                      <div
                        className="
                          s-scard-heading
                        "
                      >

                        <h3>
                          {session.title}
                        </h3>


                        {session.docUrl && (

                          <a
                            href={session.docUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="s-doc-link"
                            title={`View ${session.docLabel}`}
                            aria-label={`View ${session.docLabel} (PDF)`}
                          >
                            <i className="fas fa-file-pdf" aria-hidden="true" />
                            <span>About the Session</span>
                          </a>

                        )}


                        {session.badge && (

                          <span
                            className={`s-session-badge ${session.isKeynote

                              ? 's-keynote-badge'

                              : ''
                              }`}
                          >
                            {session.badge}
                          </span>

                        )}

                      </div>


                      {session.lines && (
                        <ul className="s-lines">
                          {session.lines.map((l, i) => (
                            <React.Fragment key={l.text}>
                              {i > 0 && (
                                <li className="s-lines-or" aria-hidden="true">or</li>
                              )}
                              <li>
                                <i className={`fas ${l.icon}`} aria-hidden="true" />
                                {l.text}
                              </li>
                            </React.Fragment>
                          ))}
                        </ul>
                      )}

                      {session.desc && (

                        session.concurrentGroup && session.desc.length > 160

                          ? <ReadMore text={session.desc} />

                          : <p>{session.desc}</p>

                      )}


                      {/* PANEL LINEUP */}

                      {session.panelists && (
                        <PanelLineup panelists={session.panelists} />
                      )}


                      {/* FACILITATORS */}

                      {session.facilitators && (
                        <Facilitators people={session.facilitators} />
                      )}


                      {/* FOUNDER × FARMER PARTICIPANTS */}

                      {(session.startupName || session.farmerName) && (

                        <div
                          className="hh-externalized-061"
                        >

                          {session.startupName && (

                            <div>

                              <span
                                className="hh-externalized-060"
                              >
                                Startup
                              </span>

                              <strong
                                className="hh-externalized-059"
                              >
                                {session.startupName}
                              </strong>

                            </div>

                          )}


                          {session.farmerName && (

                            <div>

                              <span
                                className="hh-externalized-060"
                              >
                                Farmer
                              </span>

                              <strong
                                className="hh-externalized-059"
                              >
                                {session.farmerName}
                              </strong>

                            </div>

                          )}

                        </div>

                      )}


                      {/* FTAC SESSION CHAIRS — ONLY SHOWN WHEN PROVIDED */}

                      {session.chairName && (

                        <div
                          className={`s-session-leadership ${session.coChairName ? 'has-cochair' : 'single-chair'}`}
                        >

                          <div>

                            <span
                              className="hh-externalized-060"
                            >
                              Chair
                            </span>

                            <strong
                              className="hh-externalized-059"
                            >
                              {session.chairName}
                            </strong>

                            <a
                              href={`mailto:${session.chairEmail}`}
                              onClick={(event) => event.stopPropagation()}
                              className="hh-externalized-058"
                            >
                              <i
                                className="fas fa-envelope hh-externalized-057"
                                
                              />

                              {session.chairEmail}
                            </a>

                          </div>


                          {session.coChairName && (

                            <div>

                              <span
                                className="hh-externalized-060"
                              >
                                Co-Chair
                              </span>

                              <strong
                                className="hh-externalized-059"
                              >
                                {session.coChairName}
                              </strong>

                              {session.coChairEmail && (

                                <a
                                  href={`mailto:${session.coChairEmail}`}
                                  onClick={(event) => event.stopPropagation()}
                                  className="hh-externalized-058"
                                >
                                  <i
                                    className="fas fa-envelope hh-externalized-057"
                                    
                                  />

                                  {session.coChairEmail}
                                </a>

                              )}

                            </div>

                          )}

                        </div>

                      )}


                      {/* KEYNOTE SPEAKER — NAME + BIO */}

                      {session.isKeynote && (

                        <div
                          className="
                            s-keynote-speaker-meta
                          "
                        >

                          <span>
                            Keynote Speaker
                          </span>

                          <strong>
                            {session.speakerName}
                          </strong>

                          <small
                            className="hh-externalized-056"
                          >
                            {session.speakerRole}
                          </small>

                          <p
                            className="hh-externalized-055"
                          >
                            {session.speakerBio}
                          </p>

                        </div>

                      )}



                    </div>


                    {/* KEYNOTE PHOTO */}

                    {session.isKeynote && (

                      <div
                        className="
                          s-keynote-portrait-area
                        "
                      >

                        <div
                          className="
                            s-keynote-portrait-glow
                          "
                        />


                        <div
                          className="
                            s-keynote-portrait-frame
                          "
                        >

                          <img
                            src={
                              session.speakerImage
                            }

                            alt={
                              session.speakerName
                            }

                            className="
                              s-keynote-portrait
                            "
                          />

                        </div>


                      </div>

                    )}

                  </article>

    );

  };


  return (

    <>

      {/* =====================================================
          SPUR 2025 HIGHLIGHTS CAROUSEL
          ===================================================== */}

      <section
        className="
          hh-hero
          hh-image-hero
          hh-carousel-hero
        "
        aria-label="Spur 2025 Highlights"
      >


        <div className="hh-carousel-slides">

          {heroSlides.map(
            (slide, index) => (

              <div
                key={slide.label}

                className={`hh-carousel-slide ${index ===
                  heroSlideIndex

                  ? 'active'

                  : ''
                  }`}

                aria-hidden={
                  index !==
                  heroSlideIndex
                }
              >

                <img
                  src={slide.image}

                  alt={slide.alt}

                  className="
                    hh-image-hero-img
                  "

                  
                />

              </div>

            )
          )}

        </div>


        {/* PHOTO OVERLAY */}

        <div
          className="
            hh-carousel-photo-overlay
          "
        />


        {/* HEADING */}

        <div
          className="
            hh-carousel-highlight-label
          "
        >

          <span>
            Spur AgConverge
          </span>

          <strong>
            2025 Highlights
          </strong>

        </div>


        {/* REGISTER + PROGRAMME */}

        <div
          className="
            hh-image-hero-actions
          "
        >

          <a
            href={REGISTRATION_URL}

            target="_blank"

            rel="noopener noreferrer"

            className="
              hh-image-hero-btn
              hh-image-hero-btn-primary
            "
          >
            Register Now

            <i
              className="
                fas
                fa-arrow-right
              "
            />
          </a>


          <a
            href="#agenda"

            className="
              hh-image-hero-btn
              hh-image-hero-btn-secondary
            "
          >
            View Programme

            <i
              className="
                far
                fa-calendar-alt
              "
            />
          </a>

        </div>


        {/* PREVIOUS */}

        <button
          type="button"

          className="
            hh-carousel-arrow
            hh-carousel-arrow-left
          "

          onClick={
            previousHeroSlide
          }

          aria-label="
            Previous AgConverge highlight
          "
        >
          <i
            className="
              fas
              fa-chevron-left
            "
          />
        </button>


        {/* NEXT */}

        <button
          type="button"

          className="
            hh-carousel-arrow
            hh-carousel-arrow-right
          "

          onClick={
            nextHeroSlide
          }

          aria-label="
            Next AgConverge highlight
          "
        >
          <i
            className="
              fas
              fa-chevron-right
            "
          />
        </button>


        {/* DOTS */}

        <div
          className="
            hh-carousel-dots
          "

          aria-label="
            AgConverge carousel navigation
          "
        >

          {heroSlides.map(
            (slide, index) => (

              <button
                type="button"

                key={slide.label}

                className={`hh-carousel-dot ${index ===
                  heroSlideIndex

                  ? 'active'

                  : ''
                  }`}

                onClick={() =>
                  setHeroSlideIndex(
                    index
                  )
                }

                aria-label={`Show ${slide.label}`}

                aria-current={
                  index ===
                    heroSlideIndex

                    ? 'true'

                    : undefined
                }
              />

            )
          )}

        </div>

      </section>


      {/* =====================================================
          STATS
          ===================================================== */}

      <div className="s-stats">

        <div className="s-stats-inner">


          <div className="s-stat">

            <span className="n">
              8
            </span>

            <span className="l">
              Global startups
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              $1000
            </span>

            <span className="l">
              In Student poster awards
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              2
            </span>

            <span className="l">
              Conference days
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              $6000
            </span>

            <span className="l">
              In Farm Awards
            </span>

          </div>

        </div>

      </div>


      {/* =====================================================
          COUNTDOWN
          ===================================================== */}

      <div className="s-countdown">

        <div className="s-countdown-inner">

          <span
            className="
              s-countdown-label
            "
          >
            Countdown
          </span>


          <div
            className="
              s-countdown-units
            "
          >


            <div className="s-cu">

              <span className="n">
                {timeLeft.days}
              </span>

              <span className="l">
                Days
              </span>

            </div>


            <div className="s-cu">

              <span className="n">
                {timeLeft.hours}
              </span>

              <span className="l">
                Hrs
              </span>

            </div>


            <div className="s-cu">

              <span className="n">
                {timeLeft.minutes}
              </span>

              <span className="l">
                Min
              </span>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          WHY AGCONVERGE EXISTS
          ===================================================== */}

      <div className="s-narrative">


        <div className="s-narrative-left">

          <h2>
            Why AgConverge exists
          </h2>


          <p>
            Agriculture does not lack innovation. Every year,
            entrepreneurs launch new technologies, researchers
            generate breakthrough discoveries, and investors
            deploy capital into promising ventures. Yet many
            innovations never make it onto farms and ranches.
            Some are looking for the right customer. Others
            need additional validation. Some solve problems
            that farmers do not actually have. Many simply
            struggle to move beyond pilot projects and early
            adopters. Spur AgConverge was created to help close
            that gap.
          </p>


          <div className="s-pullquote">

            <p>
              “Adoption happens when farmers help shape
              innovation from the beginning — not after
              the pitch deck is done.”
            </p>

          </div>


          <p>
            AgConverge is focused on strengthening the
            entrepreneurial innovation ecosystem across
            agriculture, animal health, food systems, and
            climate technologies throughout Nebraska and
            the Midwest. The conference serves as a platform
            where ideas are tested, partnerships are formed,
            and technologies move closer to real-world
            adoption and impact.
          </p>

        </div>


        {/* RIGHT SIDE */}

        <div className="s-narrative-right">

        <div className="s-pillar-columns">


          <div
            className="
              s-pillar-main-column
            "
          >


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-seedling" />
              </div>

              <div>

                <h3>
                  Farmer-led validation
                </h3>

                <p>
                  Producers evaluate technologies
                  against real operational challenges —
                  economics, implementation, and fit.
                </p>

              </div>

            </div>


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-flask" />
              </div>

              <div>

                <h3>
                  Real-world environments
                </h3>

                <p>
                  Entrepreneurs gain access to
                  on-farm testing through the Spur
                  Validation Sandbox Program.
                </p>

              </div>

            </div>


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-school" />
              </div>

              <div>

                <h3>
                  Research partnerships
                </h3>

                <p>
                  Industry and academia collaborate
                  to reduce technical risk and
                  accelerate commercialization.
                </p>

              </div>

            </div>


            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-coins" />
              </div>

              <div>

                <h3>
                  Capital pathways
                </h3>

                <p>
                  Investors gain clearer signals of
                  market demand and adoption potential
                  from farmer verdicts.
                </p>

              </div>

            </div>

          </div>


          <div
            className="
              s-pillar-divider
            "
            aria-hidden="true"
          />


          {/* REGISTRATION */}

          <div
            className="
              s-ftac-resource-column
            "
          >

            <div className="s-pillar">

              <div className="s-pillar-dot">
                <i className="fas fa-rocket" />
              </div>


              <div
                className="
                  s-ftac-resource-content
                "
              >

                <h3>
                  Registration
                </h3>


                <p>
                  Startup registration, student
                  registration, agenda, and awards
                  information.
                </p>


                {/* STARTUP */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--startup
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            fas
                            fa-rocket
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          Startup Registration
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      Register your startup for the
                      Farmer Tech Adoption Challenge
                      at Spur AgConverge 2026.
                    </p>

                    <a
                      href={
                        FTAC_STARTUP_URL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        s-resource-link
                      "
                    >
                      Register Startup

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </details>


                {/* STUDENT */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--student
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            fas
                            fa-user-graduate
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          Student Poster Registration
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      Students, register to attend
                      and take part in the Student
                      Poster Session at Spur
                      AgConverge 2026.
                    </p>

                    <a
                      href={
                        STUDENT_REGISTRATION_URL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        s-resource-link
                      "
                    >
                      Register as a Student

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </details>


                {/* NEBRASKA AGTECH RESOURCES */}

                <details className="s-resource-dropdown s-resource-dropdown--agenda">

                  <summary>
                    <span className="s-resource-summary-left">
                      <span className="s-resource-icon">
                        <i className="fas fa-book-open" />
                      </span>
                      <span className="s-resource-summary-text">
                        <span className="title">Nebraska AgTech Resources</span>
                      </span>
                    </span>
                    <i className="fas fa-chevron-down s-resource-arrow" />
                  </summary>

                  <div className="s-resource-dropdown-body">
                    <p>
                      White paper from Spur and Invest
                      Nebraska benchmarking AgTech
                      investment and translation gaps
                      across Nebraska and the Midwest.
                    </p>
                    <a
                      href={NEBRASKA_AGTECH_RESOURCES_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="s-resource-link"
                    >
                      Read the White Paper
                      <i className="fas fa-external-link-alt" />
                    </a>
                  </div>

                </details>


                {/* AWARDS */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--awards
                  "
                >

                  <summary>

                    <span
                      className="
                        s-resource-summary-left
                      "
                    >

                      <span
                        className="
                          s-resource-icon
                        "
                      >
                        <i
                          className="
                            fas
                            fa-trophy
                          "
                        />
                      </span>

                      <span
                        className="
                          s-resource-summary-text
                        "
                      >
                        <span className="title">
                          Agconverge Registration
                        </span>
                      </span>

                    </span>

                    <i
                      className="
                        fas
                        fa-chevron-down
                        s-resource-arrow
                      "
                    />

                  </summary>


                  <div
                    className="
                      s-resource-dropdown-body
                    "
                  >

                    <p>
                      $6,000 in Farm Awards
                      presented to the top farmer
                      roundtables during FTAC
                      Phase 3: Producer Verdict
                      &amp; Farm Awards.
                    </p>

                    <a
                      href={
                        REGISTRATION_URL
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      className="
                        s-resource-link
                      "
                    >
                      Register Now

                      <i
                        className="
                          fas
                          fa-external-link-alt
                        "
                      />
                    </a>

                  </div>

                </details>

              </div>

            </div>

          </div>

        </div>

        <StartupShowcase items={startupLogos} />

        </div>

      </div>


      {/* =====================================================
          SPONSORS & PARTNERS — CONTINUOUS MARQUEE
          ===================================================== */}

      <section
        className="agc-sponsor-strip"
        aria-label="AgConverge sponsors and partners"
      >

        <div className="agc-sponsor-accent" />


        <div className="agc-sponsor-strip-inner">

          <div className="agc-sponsor-title">

            <span>
              Sponsors &amp; Partners
            </span>

            <div aria-hidden="true" />

          </div>


          <LogoCarousel
            items={sponsorLogos}
            label="AgConverge sponsor logos"
          />

        </div>


      </section>


      {/* =====================================================
          SESSIONS EXPLORER
          ===================================================== */}

      <section
        className="s-sessions"
        id="agenda"
      >

        <div
          className="
            s-agenda-hero
          "
        >

          <div
            className="
              s-agenda-heading
            "
          >

            <span
              className="
                s-agenda-kicker
              "
            >
              Spur AgConverge 2026
            </span>


            <h2>
              Sessions Explorer
            </h2>


            <p>
              Explore two days of keynotes,
              farmer-led technology evaluation,
              panels, demonstrations, networking,
              and conversations designed to move
              AgTech toward real-world adoption.
            </p>

          </div>


          <div
            className="
              s-agenda-meta
            "
          >

            <div
              className="
                s-agenda-meta-item
              "
            >

              <div
                className="
                  s-agenda-meta-icon
                "
              >
                <i
                  className="
                    far
                    fa-calendar
                  "
                />
              </div>

              <div>

                <span>
                  Date
                </span>

                <strong>
                  November 17–18, 2026
                </strong>

              </div>

            </div>


            <div
              className="
                s-agenda-meta-item
              "
            >

              <div
                className="
                  s-agenda-meta-icon
                "
              >
                <i
                  className="
                    fas
                    fa-map-marker-alt
                  "
                />
              </div>

              <div>

                <span>
                  Location
                </span>

                <strong>
                  Raising Nebraska
                </strong>

                <small>
                  Grand Island, Nebraska
                </small>

              </div>

            </div>

          </div>

        </div>


        {/* DAY TABS */}

        <div
          className="
            s-session-tabs
          "
          role="tablist"
          aria-label="
            Conference agenda days
          "
        >

          {tabs.map(
            (tab) => (

              <button
                type="button"

                role="tab"

                id={`${tab.key}-tab`}

                key={tab.key}

                className={`s-stab ${activeTab ===
                  tab.key

                  ? 'act'

                  : ''
                  }`}

                onClick={() =>
                  setActiveTab(
                    tab.key
                  )
                }

                aria-selected={
                  activeTab ===
                  tab.key
                }

                aria-controls={`${tab.key}-panel`}
              >

                <span
                  className="
                    s-stab-day
                  "
                >
                  {tab.day}
                </span>

                <span
                  className="
                    s-stab-date
                  "
                >
                  {tab.date}
                </span>

              </button>

            )
          )}

        </div>


        {/* SESSION CONTENT */}

        <div
          className="
            s-session-content
          "

          id={`${activeTab}-panel`}

          role="tabpanel"

          aria-labelledby={`${activeTab}-tab`}
        >

          <div
            className="
              s-agenda-day-header
            "
          >

            <div>

              <span
                className="
                  s-agenda-day-label
                "
              >
                {
                  activeTab === 'day1'

                    ? 'Tuesday'

                    : 'Wednesday'
                }
              </span>

              <h3>
                {
                  activeTab === 'day1'

                    ? 'November 17, 2026'

                    : 'November 18, 2026'
                }
              </h3>

            </div>

          </div>


          <div
            className="
              s-scontent
              act
            "
          >

            {
              buildSessionRows(
                sessionData[activeTab]
              ).map((row) =>

                row.group ? (

                  <div
                    key={row.group}
                    className="s-concurrent"
                  >

                    <div className="s-concurrent-label">
                      <i className="fas fa-clone" aria-hidden="true" />
                      Happening together
                      {row.label && (
                        <strong>{row.label}</strong>
                      )}
                    </div>

                    <div className="s-concurrent-grid">
                      {row.items.map(renderSessionCard)}
                    </div>

                  </div>

                ) : (

                  renderSessionCard(row.item)

                )

              )
            }

          </div>

        </div>

      </section>


      {/* =====================================================
          STUDENT RESEARCH & INNOVATION POSTER SESSION
          ===================================================== */}

      <section
        id="poster-session"
        className="hh-externalized-054"
      >

        {/* SUBTLE BACKGROUND TYPOGRAPHY */}

        <div
          aria-hidden="true"
          className="hh-externalized-053"
        >
          POSTER
        </div>


        <div
          className="hh-externalized-052"
        >

          <div
            className="hh-externalized-051"
          >

            {/* CONTENT */}

            <div>

              <span
                className="hh-externalized-050"
              >
                <i className="fas fa-flask" />
                Student Research &amp; Innovation
              </span>


              <h2
                className="hh-externalized-049"
              >
                Poster
                <br />
                Session
              </h2>


              <p
                className="hh-externalized-048"
              >
                Put your research in front of the people
                who can use it, fund it, build on it, and
                help move it toward real-world impact.
                Undergraduate and graduate researchers
                will present to producers, startups,
                industry partners, and investors throughout
                Spur AgConverge 2026.
              </p>


              <div
                className="hh-externalized-047"
              >

                {[
                  ['Dates', 'Nov. 17–18, 2026'],
                  ['Venue', 'Raising Nebraska'],
                  ['Registration closes', 'Oct. 31, 2026'],
                ].map(([label, value]) => (

                  <div key={label}>
                    <span
                      className="hh-externalized-046"
                    >
                      {label}
                    </span>

                    <strong
                      className="hh-externalized-045"
                    >
                      {value}
                    </strong>
                  </div>

                ))}

              </div>


              <div
                className="hh-externalized-044"
              >

                <a
                  href={STUDENT_REGISTRATION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hh-externalized-043"
                >
                  Register for Poster Session
                  <i className="fas fa-arrow-right" />
                </a>


                <a
                  href="mailto:ilal2@unl.edu"
                  className="hh-externalized-042"
                >
                  Questions? Contact Ishani Lal
                </a>

              </div>

            </div>


            {/* CLICKABLE POSTER ARTWORK */}

            <div
              className="hh-externalized-041"
            >

              <div
                aria-hidden="true"
                className="hh-externalized-040"
              />


              <button
                type="button"
                onClick={() =>
                  setPosterImageOpen(true)
                }
                aria-label="Enlarge Student Research and Innovation Poster Session flyer"
                className="hh-externalized-039"
              >

                <img
                  src={PosterSessionFlyer}
                  alt="Spur AgConverge 2026 Student Research and Innovation Poster Session"
                  className="hh-externalized-038"
                />


                <span
                  className="hh-externalized-037"
                >
                  <i className="fas fa-search-plus" />
                  Click to enlarge
                </span>

              </button>

            </div>

          </div>


          {/* AWARDS STRIP */}

          <div
            className="hh-externalized-036"
          >

            <div
              className="hh-externalized-035"
            >
              <span
                className="hh-externalized-034"
              >
                External Panel Judging
              </span>

              <strong
                className="hh-externalized-033"
              >
                $1,000 in student poster awards
              </strong>

              <span
                className="hh-externalized-032"
              >
                Be ready to give a 2–3 minute overview
                during the Day 1 networking reception.
              </span>
            </div>


            {[
              ['1st', '$500'],
              ['2nd', '$300'],
              ['3rd', '$200'],
            ].map(([place, amount]) => (

              <div
                key={place}
                className="hh-externalized-031"
              >
                <span
                  className="hh-externalized-030"
                >
                  {place} Place
                </span>

                <strong
                  className="hh-externalized-029"
                >
                  {amount}
                </strong>
              </div>

            ))}

          </div>


          {/* RESEARCH AREAS */}

          <div
            className="hh-externalized-028"
          >


            <span
              className="hh-externalized-027"
            >
              Research Areas
            </span>


            <div
              className="hh-externalized-011"
            >

              {[
                'Agricultural Technology',
                'Precision Agriculture',
                'Robotics & Automation',
                'Biosystems Engineering',
                'Artificial Intelligence & Data Science',
                'Water & Nutrient Management',
                'Bio-economy',
                'Crop Production',
                'Sustainability',
              ].map((area) => (

                <span
                  key={area}
                  className="hh-externalized-026"
                >
                  {area}
                </span>

              ))}

            </div>


          </div>


          {/* PRESENTER INSTRUCTIONS */}

          <details
            className="poster-presenter-instructions hh-externalized-025"
            
          >

            <summary
              className="hh-externalized-024"
            >

              <span>

                <span
                  className="hh-externalized-023"
                >
                  For Student Presenters
                </span>

                <strong
                  className="hh-externalized-022"
                >
                  Presenter Instructions
                </strong>

                <span
                  className="hh-externalized-021"
                >
                  Review poster format, setup, judging,
                  presentation, and networking expectations.
                </span>

              </span>


              <span
                className="poster-instructions-toggle hh-externalized-020"
                aria-hidden="true"
                
              >
                <i className="fas fa-chevron-down" />
              </span>

            </summary>


            <div
              className="poster-instructions-body hh-externalized-019"
              
            >

              <div
                className="hh-externalized-018"
              >

                {/* BEFORE THE EVENT */}

                <div>

                  <span
                    className="hh-externalized-017"
                  >
                    Before the Event
                  </span>

                  <ul
                    className="hh-externalized-016"
                  >
                    <li>
                      Review your poster with your faculty
                      mentor before the event.
                    </li>
                    <li>
                      One poster is allowed per student.
                    </li>
                    <li>
                      Your work should reflect research or
                      innovation you were substantially
                      involved in during the past year.
                    </li>
                    <li>
                      Watch your email for your poster number
                      and board assignment.
                    </li>
                  </ul>

                </div>


                {/* POSTER FORMAT */}

                <div>

                  <span
                    className="hh-externalized-017"
                  >
                    Poster Format
                  </span>

                  <ul
                    className="hh-externalized-016"
                  >
                    <li>
                      Maximum size: 29 × 40 inches or
                      39 × 48 inches, in either orientation.
                    </li>
                    <li>
                      Do not mount the poster on poster board
                      or foam core.
                    </li>
                    <li>
                      Display board, easel, pushpins, or clips
                      will be provided on site.
                    </li>
                  </ul>

                </div>


                {/* CONTENT + DESIGN */}

                <div>

                  <span
                    className="hh-externalized-017"
                  >
                    Content &amp; Design
                  </span>

                  <ul
                    className="hh-externalized-016"
                  >
                    <li>
                      Explain the problem, your approach,
                      results, and real-world application or
                      impact.
                    </li>
                    <li>
                      Design for producers, startups,
                      industry partners, and investors—not
                      only researchers.
                    </li>
                    <li>
                      Keep jargon limited and spell out
                      acronyms.
                    </li>
                    <li>
                      Aim for roughly 20% text, 40% graphics,
                      and 40% open space.
                    </li>
                    <li>
                      Use a clear sans-serif font with a title
                      at 40 pt or larger, section headings
                      around 36 pt, captions around 24 pt,
                      and narrative text no smaller than
                      18 pt.
                    </li>
                  </ul>

                </div>


                {/* PRESENTING */}

                <div>

                  <span
                    className="hh-externalized-017"
                  >
                    At the Reception
                  </span>

                  <ul
                    className="hh-externalized-016"
                  >
                    <li>
                      Be ready to give a 2–3 minute overview
                      of your work and answer questions.
                    </li>
                    <li>
                      Stand beside your poster rather than in
                      front of it.
                    </li>
                    <li>
                      Practice a short explanation that makes
                      sense to a farmer, investor, and
                      scientist.
                    </li>
                    <li>
                      Business cards, a one-page handout, or
                      a QR code linking to your paper, lab
                      page, or contact information are
                      encouraged.
                    </li>
                    <li>
                      Dress business casual and use the
                      reception as a networking opportunity.
                    </li>
                  </ul>

                </div>

              </div>


              {/* JUDGING */}

              <div
                className="hh-externalized-015"
              >

                <div>

                  <span
                    className="hh-externalized-014"
                  >
                    Judging
                  </span>

                  <strong
                    className="hh-externalized-013"
                  >
                    External judges will visit each poster
                    during the Day 1 networking reception.
                  </strong>

                </div>


                <div>

                  <span
                    className="hh-externalized-012"
                  >
                    Judges Will Consider
                  </span>

                  <div
                    className="hh-externalized-011"
                  >

                    {[
                      'Significance & relevance',
                      'Research & methods',
                      'Innovation & real-world potential',
                      'Poster clarity & design',
                      'Communication with judges',
                    ].map((item) => (

                      <span
                        key={item}
                        className="hh-externalized-010"
                      >
                        {item}
                      </span>

                    ))}

                  </div>

                </div>

              </div>


              {/* KEY TIMING */}

              <div
                className="hh-externalized-009"
              >

                <span
                  className="hh-externalized-008"
                >
                  Key Timing
                </span>


                <div
                  className="hh-externalized-007"
                >

                  <div>
                    <strong
                      className="hh-externalized-006"
                    >
                      Nov. 17 · 9:00 AM
                    </strong>

                    <span
                      className="hh-externalized-005"
                    >
                      Poster setup
                    </span>
                  </div>


                  <div>
                    <strong
                      className="hh-externalized-006"
                    >
                      Nov. 17 · 5:00 PM
                    </strong>

                    <span
                      className="hh-externalized-005"
                    >
                      Presenter staffing &amp; judging
                    </span>
                  </div>


                  <div>
                    <strong
                      className="hh-externalized-006"
                    >
                      Nov. 18 · 1:00 PM
                    </strong>

                    <span
                      className="hh-externalized-005"
                    >
                      Poster removal
                    </span>
                  </div>

                </div>

              </div>

            </div>

          </details>

        </div>


        {/* POSTER IMAGE LIGHTBOX */}

        {posterImageOpen && (

          <div
            role="dialog"
            aria-modal="true"
            aria-label="Enlarged Student Poster Session flyer"
            onClick={() =>
              setPosterImageOpen(false)
            }
            className="hh-externalized-004"
          >

            <button
              type="button"
              onClick={() =>
                setPosterImageOpen(false)
              }
              aria-label="Close enlarged poster"
              className="hh-externalized-003"
            >
              <i className="fas fa-times" />
            </button>


            <img
              src={PosterSessionFlyer}
              alt="Enlarged Spur AgConverge 2026 Student Research and Innovation Poster Session flyer"
              onClick={(event) =>
                event.stopPropagation()
              }
              className="hh-externalized-002"
            />

          </div>

        )}


        

      </section>


      {/* =====================================================
          HOTEL & TRAVEL — RESPONSIVE MAP + HOTEL NAVIGATOR
          ===================================================== */}

      <section
        id="travel"
        className="travel-section"
      >

        <div className="travel-wrap">

          {/* HEADER */}

          <div className="travel-heading">

            <div>

              <span className="travel-kicker">
                <i className="fas fa-map-marked-alt" />
                Plan Your Visit
              </span>

              <h2>
                Raising Nebraska
                <br />
                + Nearby Hotels
              </h2>

            </div>


            <p>
              Start with the conference venue and nearby
              lodging. Select a hotel from the navigator to
              focus the map and open its details without
              changing the map layout.
            </p>

          </div>


          {/* MAP + NAVIGATOR */}

          <div className="travel-map-shell">

            {/* MAP SIDE */}

            <div className="travel-map-side">

              {/* CONTROLS LIVE ABOVE THE MAP — NOTHING COVERS GOOGLE */}

              <div className="travel-map-toolbar">

                <div className="travel-venue-summary">

                  <span>
                    Conference Venue
                  </span>

                  <strong>
                    Raising Nebraska
                  </strong>

                  <small>
                    501 E. Fonner Park Road, Suite 100
                    <br className="travel-mobile-break" />
                    <span className="travel-address-dot">
                      {' · '}
                    </span>
                    Grand Island, NE 68801
                  </small>

                </div>


                <div className="travel-map-actions">

                  <button
                    type="button"
                    onClick={() =>
                      focusTravelLocation(
                        'Hotels near Raising Nebraska, Grand Island, Nebraska'
                      )
                    }
                  >
                    <i className="fas fa-hotel" />
                    Nearby hotels
                  </button>


                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Raising+Nebraska+501+E+Fonner+Park+Road+Grand+Island+NE+68801"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fas fa-external-link-alt" />
                    Open in Maps
                  </a>

                </div>

              </div>


              {/* CLEAN MAP CANVAS */}

              <div className="travel-map-canvas">

                <iframe
                  title="Raising Nebraska and nearby AgConverge hotels"
                  src={travelMapEmbedUrl}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />

              </div>

            </div>


            {/* HOTEL NAVIGATOR */}

            <aside className="travel-hotel-nav">

              <div className="travel-hotel-nav-head">

                <span>
                  Nearby Lodging
                </span>

                <strong>
                  Hotel Navigator
                </strong>

                <p>
                  Select a hotel to focus the map and
                  open its information.
                </p>

              </div>


              <div className="travel-hotel-list">

                {hotelOptions.map(
                  (hotel, index) => {

                    const isSelected =
                      selectedHotelName ===
                      hotel.name;

                    return (

                      <button
                        key={hotel.name}
                        type="button"
                        className={`travel-hotel-tab ${isSelected
                            ? 'is-selected'
                            : ''
                          }`}
                        onClick={() =>
                          focusTravelLocation(
                            `${hotel.name}, ${hotel.address}`,
                            hotel.name
                          )
                        }
                      >

                        <span className="travel-hotel-number">
                          {String(index + 1).padStart(2, '0')}
                        </span>


                        <span className="travel-hotel-copy">

                          <span className="travel-hotel-name-row">

                            <strong>
                              {hotel.name}
                            </strong>

                            {hotel.isOfficialBlock && (
                              <span className="travel-official-pill">
                                Official
                              </span>
                            )}

                          </span>


                          <span className="travel-hotel-label">
                            {hotel.label}
                          </span>


                          {hotel.isOfficialBlock && (
                            <span className="travel-hotel-rate-preview">
                              {hotel.specialRate}
                              {' · '}
                              Code {hotel.groupCode}
                            </span>
                          )}

                        </span>


                        <span className="travel-hotel-action">
                          {isSelected
                            ? 'Open'
                            : 'View'}
                        </span>

                      </button>

                    );

                  }
                )}

              </div>


              <div className="travel-nav-foot">
                Grand Island Casino Resort is the official
                Spur AgConverge 2026 hotel.
              </div>


              {/* FLOATING DETAILS — DOES NOT CHANGE MAP OR NAV HEIGHT */}

              {selectedHotel && (

                <div className="travel-floating-hotel">

                  <button
                    type="button"
                    className="travel-floating-close"
                    onClick={() =>
                      focusTravelLocation(
                        'Hotels near Raising Nebraska, Grand Island, Nebraska'
                      )
                    }
                    aria-label="Close hotel details"
                  >
                    <i className="fas fa-times" />
                  </button>


                  <span className="travel-floating-eyebrow">
                    {selectedHotel.isOfficialBlock
                      ? 'Official AgConverge Hotel'
                      : 'Selected Hotel'}
                  </span>


                  <h4>
                    {selectedHotel.name}
                  </h4>


                  <p className="travel-floating-description">
                    {selectedHotel.description}
                  </p>


                  <div className="travel-floating-contact">

                    <div>
                      <i className="fas fa-map-marker-alt" />
                      {selectedHotel.address}
                    </div>

                    <div>
                      <i className="fas fa-phone" />
                      {selectedHotel.phone}
                    </div>

                  </div>


                  {selectedHotel.isOfficialBlock && (

                    <div className="travel-rate-box">

                      <div className="travel-rate-grid">

                        <div>
                          <span>Rate</span>
                          <strong>
                            {selectedHotel.specialRate}
                          </strong>
                        </div>

                        <div>
                          <span>
                            Discount / Group Code
                          </span>
                          <strong>
                            {selectedHotel.groupCode}
                          </strong>
                        </div>

                        <div>
                          <span>
                            Book By
                          </span>
                          <strong>
                            {selectedHotel.bookBy}
                          </strong>
                        </div>

                      </div>


                      <p>
                        {selectedHotel.blockMessage}
                      </p>

                    </div>

                  )}


                  <div className="travel-floating-actions">

                    <a
                      href={selectedHotel.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={
                        selectedHotel.isOfficialBlock
                          ? 'is-primary'
                          : ''
                      }
                    >
                      {selectedHotel.isOfficialBlock
                        ? 'Book Hotel'
                        : 'Hotel Website'}

                      <i className="fas fa-arrow-right" />
                    </a>


                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        `${selectedHotel.name} ${selectedHotel.address}`
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Directions
                      <i className="fas fa-location-arrow" />
                    </a>

                  </div>

                </div>

              )}

            </aside>

          </div>


          {/* TRAVEL ESSENTIALS */}

          <div className="travel-essentials">

            {[
              [
                'Parking',
                'Free accessible parking is available on the west side of the Nebraska Building.',
              ],
              [
                'Airport',
                'Central Nebraska Regional Airport serves Grand Island.',
              ],
              [
                'Local transportation',
                'Rental cars, local transit, taxi service, and regional rail connections are available.',
              ],
            ].map(([title, copy]) => (

              <div key={title}>

                <span>
                  {title}
                </span>

                <p>
                  {copy}
                </p>

              </div>

            ))}

          </div>


          {/* =====================================================
              FTAC POSTER — FEATURED UNDER HOTEL & TRAVEL
              ===================================================== */}

          <div className="travel-ftac-poster">

            <div className="travel-ftac-poster-heading">

              <div>

                <span>
                  Featured at Spur AgConverge 2026
                </span>

                <h3>
                  Farm Tech Adoption Challenge™
                </h3>

              </div>


              <p>
                Farmer-led technology evaluation,
                real-world feedback, and $6,000 in
                Farm Table prizes.
              </p>

            </div>


            <button
              type="button"
              className="travel-ftac-poster-button"
              onClick={() =>
                setFtacPosterOpen(true)
              }
              aria-label="Enlarge Farm Tech Adoption Challenge poster"
            >

              <img
                src={FTACPoster}
                alt="Farm Tech Adoption Challenge at Spur AgConverge 2026"
              />


              <span className="travel-ftac-zoom-label">
                <i className="fas fa-search-plus" />
                Click to enlarge
              </span>

            </button>


            <div className="travel-ftac-poster-actions">

              <span>
                Nov. 17–18, 2026 · Raising Nebraska,
                Grand Island, NE
              </span>


              <a
                href={FTAC_STARTUP_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Register for FTAC
                <i className="fas fa-arrow-right" />
              </a>

            </div>

          </div>


          {/* FTAC POSTER LIGHTBOX */}

          {ftacPosterOpen && (

            <div
              className="travel-ftac-lightbox"
              role="dialog"
              aria-modal="true"
              aria-label="Enlarged Farm Tech Adoption Challenge poster"
              onClick={() =>
                setFtacPosterOpen(false)
              }
            >

              <button
                type="button"
                className="travel-ftac-lightbox-close"
                onClick={() =>
                  setFtacPosterOpen(false)
                }
                aria-label="Close enlarged FTAC poster"
              >
                <i className="fas fa-times" />
              </button>


              <img
                src={FTACPoster}
                alt="Enlarged Farm Tech Adoption Challenge at Spur AgConverge 2026"
                onClick={(event) =>
                  event.stopPropagation()
                }
              />

            </div>

          )}

        </div>


        

      </section>


      {/* =====================================================
          FARMERS TECH ADOPTION CHALLENGE
          ===================================================== */}

      <div className="s-ftac">

        <div className="s-ftac-inner">

          <h2>
            The Farm Tech Adoption
            Challenge™
          </h2>


          <p className="sub">
            A first-of-its-kind farmer-led market
            validation platform — the only event
            in agriculture where producers
            evaluate technologies live, on stage,
            in front of investors and industry.
          </p>


          <div
            className="
              s-ftac-track
            "
          >


            <div className="s-fbox">

              <div
                className="
                  s-fbox-phase
                "
              >
                Phase 01
              </div>

              <div
                className="
                  s-fbox-num
                "
              >
                01
              </div>

              <h3>
                Startup Showcase
              </h3>

              <p>
                8 selected startups ·
                8 minutes each · live
                Q&amp;A · technologies
                from across the U.S.
                and the world
              </p>

            </div>


            <div className="s-farrow">
              <i
                className="
                  fas
                  fa-arrow-right
                "
              />
            </div>


            <div
              className="
                s-fbox
                center
              "
            >

              <div
                className="
                  s-fbox-phase
                "
              >
                Phase 02
              </div>

              <div
                className="
                  s-fbox-num
                "
              >
                02
              </div>

              <h3>
                Farmer Roundtables
              </h3>

              <p>
                Producers evaluate each
                technology on economics,
                ease of implementation,
                scalability, and adoption
                likelihood
              </p>

            </div>


            <div className="s-farrow">
              <i
                className="
                  fas
                  fa-arrow-right
                "
              />
            </div>


            <div className="s-fbox">

              <div
                className="
                  s-fbox-phase
                "
              >
                Phase 03
              </div>

              <div
                className="
                  s-fbox-num
                "
              >
                03
              </div>

              <h3>
                Producer Verdict
              </h3>

              <p>
                Roundtables report findings ·
                independent judges score ·
                Farm Awards presented ·
                commercialization pathways
                identified
              </p>

            </div>

          </div>


          <div
            className="
              s-ftac-cta
            "
          >

            <button
              type="button"

              className="
                btn-og3
              "

              onClick={
                openRegistration
              }
            >
              Register for FTAC™
            </button>

          </div>

        </div>

      </div>


      {/* =====================================================
          VENUE
          ===================================================== */}

      <div className="s-venue">

        <div
          className="
            s-venue-inner
          "
        >


          <div className="s-v">

            <div className="s-v-label">
              Venue
            </div>

            <div className="s-v-val">
              Raising Nebraska
            </div>

            <div className="s-v-sub">
              Grand Island,
              Nebraska 68801
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Date
            </div>

            <div className="s-v-val">
              November 17, 2026
            </div>

            <div className="s-v-sub">
              8:00 AM – 6:30 PM
            </div>

            <div className="s-v-val">
              November 18, 2026
            </div>

            <div className="s-v-sub">
              8:00 AM – 12:00 PM
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Hosted by
            </div>

            <div className="s-v-val">
              Spur Ventures at UNL
            </div>

            <div className="s-v-sub">
              University of
              Nebraska–Lincoln
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Parking
            </div>

            <div className="s-v-val">
              Free on-site
            </div>

            <div className="s-v-sub">
              ADA accessible ·
              WiFi included
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Catering
            </div>

            <div className="s-v-val">
              Breakfast &amp; lunch
            </div>

            <div className="s-v-sub">
              Included with registration
            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          CLOSING CTA
          ===================================================== */}

      <div className="s-cta">

        <h2>
          Join AgConverge '26
        </h2>


        <p>
          The result is more than a conference —
          a platform for validation, adoption,
          ecosystem building, and investment in
          the Midwest&apos;s agricultural future.
        </p>


        <button
          type="button"

          className="btn-og3 hh-externalized-001"

          

          onClick={
            openRegistration
          }
        >
          Register Now
        </button>

      </div>

    </>

  );

};


export default HarvestHorizonHero;